var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('SideMenubar')],1),_c('v-main',[_c('div',[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }